import { render } from "./community_view.vue?vue&type=template&id=390f3022"
import script from "./community_view.vue?vue&type=script&lang=js"
export * from "./community_view.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__